import React from 'react';
import styled from 'styled-components';
import rmq from 'styled-rmq';
import checked from '../../images/checked.svg';
import Anchor from '../Basic/Anchor';
import EStar from '../Emoji/EStar';
import EVideo from '../Emoji/EVideo';
import Spacer from './Spacer';

const Features = styled.div`
	margin: ${props => props.theme.vr * 2}rem auto;
`;
const Feature = styled.p`
	margin: 1rem auto;
	max-width: 40rem;

	.ftr,
	.mdl {
		padding-left: 0.5rem;
	}

	${rmq('ls')} {
		font-size: 1.6rem;
	}
	${rmq('830')} {
		font-size: 1.5rem;
	}
	${rmq('800')} {
		font-size: 1.4rem;
	}

	${rmq('t')} {
		font-size: 1.8rem;
	}
	${rmq('470')} {
		font-size: 1.6rem;
	}
	${rmq('395')} {
		font-size: 1.4rem;
	}
	${rmq('335')} {
		.ftr,
		.mdl {
			display: table;
			padding: 0.5rem 0 1rem 3rem;
		}
	}
	svg,
	img {
		width: 2.8rem;
		height: auto;
		padding: 0 1rem 0 0;
	}

	img {
		vertical-align: middle;
	}

	.mdl--1,
	.mdl--2,
	.mdl--3,
	.mdl--4 {
		background: ${props => props.theme.gray2};
	}
	.mdl--5,
	.mdl--6,
	.mdl--7,
	.mdl--8,
	.mdl--9 {
		background: ${props => props.theme.grgreen4};
	}
`;

const Module = styled.span`
	padding: 0.5rem 1.1rem;
	margin: 0 0.5rem;
	font-size: 1.2rem;
	letter-spacing: 3px;
	background: ${props => props.theme.c};
	font-family: monospace !important;
	color: #4e4e4e;

	${rmq('ml')} {
		font-size: 1rem;
	}
`;

export default ({ features, modules, recommend }) => (
	<Features>
		{features.map((feature, i) => (
			<Feature key={i}>
				{recommend && i === 0 ? (
					<EStar width="24" height="24" />
				) : (
					<img alt="✅" loading="lazy" className="lazyload" data-src={checked} />
				)}
				<span dangerouslySetInnerHTML={{ __html: feature }} />
			</Feature>
		))}
		<Spacer />
		{modules.map((module, i) => (
			<Feature key={i}>
				<Anchor href={`#module${i + 1}`}>
					<EVideo width="24" height="24" />
					<Module className={`mdl--${i + 1}`}>MODULE #{`${i + 1}`}</Module>
					<span className="mdl">{module}</span>
				</Anchor>
			</Feature>
		))}
	</Features>
);
